export default "__VITE_ASSET__CQCfhGeX__"